export function handleShellSessionExpiry(status, {
  storage = window.localStorage,
  windowRef = window
} = {}) {
  if (status !== 401) return false;

  storage.removeItem('user_access_token');
  windowRef.dispatchEvent(new windowRef.CustomEvent('eurekers:session-expired'));
  if (!String(windowRef.location.pathname || '').includes('/app/login')) {
    windowRef.location.assign('/app/login');
  }
  return true;
}
